import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['output']
  static values = {
    words: Array,
    typeMs: { type: Number, default: 85 },
    deleteMs: { type: Number, default: 40 },
    holdMs: { type: Number, default: 1500 }
  }

  connect () {
    if (!this.hasOutputTarget || this.wordsValue.length === 0) return

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.outputTarget.textContent = this.wordsValue[0]
      return
    }

    this.wordIndex = 0
    this.charIndex = 0
    this.deleting = false
    this.tick()
  }

  disconnect () {
    clearTimeout(this.timer)
  }

  tick () {
    const word = this.wordsValue[this.wordIndex]

    if (!this.deleting) {
      this.charIndex++
      this.outputTarget.textContent = word.slice(0, this.charIndex)

      if (this.charIndex === word.length) {
        this.deleting = true
        this.timer = setTimeout(() => this.tick(), this.holdMsValue)
        return
      }
      this.timer = setTimeout(() => this.tick(), this.typeMsValue)
    } else {
      this.charIndex--
      this.outputTarget.textContent = word.slice(0, this.charIndex)

      if (this.charIndex === 0) {
        this.deleting = false
        this.wordIndex = (this.wordIndex + 1) % this.wordsValue.length
      }
      this.timer = setTimeout(() => this.tick(), this.deleteMsValue)
    }
  }
}
